import { WorkerByTypeSchema } from "../../../api-client";
import { NICE_TAG_NAMES } from "./constants";

export const showWorkerStatus = (workerType: WorkerByTypeSchema): string => {
  const quotaError =
    workerType.errorCount && workerType.errorCount.quota
      ? `${workerType.errorCount.quota} quota error${workerType.errorCount.quota > 1 ? "s" : ""}`
      : "";
  const availError =
    workerType.errorCount && workerType.errorCount.availability
      ? `${workerType.errorCount.availability} availability error${workerType.errorCount.availability > 1 ? "s" : ""}`
      : "";

  const interruptionError =
    workerType.errorCount && workerType.errorCount.interruption
      ? `${workerType.errorCount.interruption} spot interruption${workerType.errorCount.interruption > 1 ? "s" : ""}`
      : "";

  const otherError =
    workerType.errorCount && workerType.errorCount.other
      ? `${workerType.errorCount.other} ${quotaError || availError ? "other" : ""} error${workerType.errorCount.other > 1 ? "s" : ""}`
      : "";

  const errorString = [
    quotaError,
    availError,
    interruptionError,
    otherError,
  ].reduce((previousValue, currentValue) =>
    previousValue && currentValue
      ? `${previousValue} and ${currentValue}`
      : previousValue || currentValue,
  );

  return workerType.errorCount
    ? errorString
    : `${workerType.count} ${workerType.stateName}`;
};

export const showWorkerSpotCount = (workerType: WorkerByTypeSchema): string => {
  const all = workerType.count > 1 ? "all " : "";
  return workerType.spot
    ? workerType.spot === workerType.count
      ? `${all}spot`
      : ` ${workerType.spot} spot + ${workerType.count - workerType.spot} on-demand`
    : ` ${all}on-demand`;
};

export const prettyTagLabel = (label: string): string => {
  const s = label.split("/");
  return NICE_TAG_NAMES[label] || s[s.length - 1];
};

export const getClustersColumnVisibilityModel = (
  storageKey: string,
  initialVisibility: Record<string, boolean>,
  hideByDefaultKeys: string[],
): Record<string, boolean> => {
  const extraDefaultHides: Record<string, boolean> = {};
  hideByDefaultKeys.forEach((key) => {
    extraDefaultHides[key] = false;
  });
  const defaultVisibility = {
    ...initialVisibility,
    ...extraDefaultHides,
  };
  try {
    const model = localStorage.getItem(storageKey);
    if (model) {
      return {
        ...defaultVisibility,
        ...JSON.parse(model),
        ...{ name: true }, // ALWAYS_VISIBLE_COLUMNS
      };
    }
  } catch {
    // no-op: return default
  }
  return defaultVisibility;
};

export const getClustersColumnOrderModel = (
  storageKey: string,
  defaultColumnOrder: string[],
): string[] => {
  try {
    const model = localStorage.getItem(storageKey);
    if (model) {
      return JSON.parse(model);
    }
  } catch {
    // no-op: return default
  }
  return defaultColumnOrder;
};
